import { EditOutlined, LoadingOutlined } from '@ant-design/icons'
import { DatePicker, DatePickerProps } from 'antd'
import dayjs from 'dayjs'
import classNames from 'classnames'
import { FC, useEffect, useState } from 'react'
import ProcessedCheckIcon from '../ProcessedCheckIcon/ProcessedCheckIcon'
import cn from './index.module.css'

interface IEndDateWithProcessedCell {
  date: string | null
  processed?: boolean | 0 | 1 | null
  dateLoading?: boolean
  processedLoading?: boolean
  popupPlacement?: 'bottomLeft' | 'bottomRight' | 'topLeft' | 'topRight'
  closeOnScroll?: boolean
  onDateChange: (date: string | null) => void
  onToggleProcessed: () => void
}

const EndDateWithProcessedCell: FC<IEndDateWithProcessedCell> = ({
  date,
  processed,
  dateLoading = false,
  processedLoading = false,
  popupPlacement = 'bottomLeft',
  closeOnScroll = false,
  onDateChange,
  onToggleProcessed,
}) => {
  const [edit, setEdit] = useState(false)
  const [dateValue, setDateValue] = useState<dayjs.Dayjs | null>(
    date ? dayjs(date) : null,
  )

  useEffect(() => {
    setDateValue(date ? dayjs(date) : null)
  }, [date])

  useEffect(() => {
    if (!closeOnScroll || !edit) {
      return undefined
    }

    const closeCalendar = () => setEdit(false)

    document.addEventListener('scroll', closeCalendar, true)

    return () => {
      document.removeEventListener('scroll', closeCalendar, true)
    }
  }, [closeOnScroll, edit])

  const onValueChange: DatePickerProps['onChange'] = (nextDate) => {
    setDateValue(nextDate ?? null)
    onDateChange(nextDate?.isValid() ? nextDate.format('YYYY-MM-DD') : null)
    setEdit(false)
  }

  return (
    <div className={cn.wrapper}>
      {edit ? (
        <DatePicker
          className={cn.datePicker}
          value={dateValue}
          format="DD.MM.YYYY"
          allowClear
          autoFocus
          open
          disabled={dateLoading}
          placement={popupPlacement}
          getPopupContainer={() => document.body}
          onChange={onValueChange}
          onOpenChange={(open) => {
            if (!open) setEdit(false)
          }}
        />
      ) : (
        <>
          <span
            className={classNames(
              cn.dateText,
              dateLoading && cn.dateTextLoading,
            )}
          >
            {dateValue?.isValid() ? dateValue.format('DD.MM.YYYY') : '—'}
          </span>
          {dateLoading ? (
            <span className={cn.dateLoading} aria-label="Сохранение даты">
              <LoadingOutlined
                spin
                onPointerEnterCapture={undefined}
                onPointerLeaveCapture={undefined}
              />
            </span>
          ) : (
            <button
              type="button"
              className={cn.editButton}
              onClick={() => setEdit(true)}
              aria-label="Изменить дату завершения"
            >
              <EditOutlined
                onPointerEnterCapture={undefined}
                onPointerLeaveCapture={undefined}
              />
            </button>
          )}
        </>
      )}
      <ProcessedCheckIcon
        processed={processed}
        loading={processedLoading}
        onToggle={onToggleProcessed}
      />
    </div>
  )
}

export default EndDateWithProcessedCell
